var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91663 4.91669H8.41663V15.8334C8.41663 16.7999 7.63312 17.5834 6.66663 17.5834C5.70013 17.5834 4.91663 16.7999 4.91663 15.8334V4.91669Z",
    stroke: "#4E4B66",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.20833,
    y: 3.54165,
    width: 2.91667,
    height: 0.416667,
    stroke: "#4E4B66",
    strokeWidth: 0.416667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70318 2.58335H4.63023L4.5469 2.41669H8.78652L8.70318 2.58335Z",
    stroke: "#4E4B66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0834 11.6667C15.0834 12.6332 14.2999 13.4167 13.3334 13.4167C12.3669 13.4167 11.5834 12.6332 11.5834 11.6667C11.5834 11.0227 11.8863 10.1568 12.3668 9.27583C12.6656 8.72811 13.0094 8.21729 13.3334 7.80426C13.6574 8.21729 14.0012 8.72811 14.3 9.27583C14.7805 10.1568 15.0834 11.0227 15.0834 11.6667Z",
    stroke: "#4E4B66",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/Test.55fcb050.svg";
export { ForwardRef as ReactComponent };